import { render } from "./VendorUpdateItemInfoPopUp.vue?vue&type=template&id=367d3ebc&scoped=true"
import script from "./VendorUpdateItemInfoPopUp.vue?vue&type=script&lang=js"
export * from "./VendorUpdateItemInfoPopUp.vue?vue&type=script&lang=js"

import "./VendorUpdateItemInfoPopUp.vue?vue&type=style&index=0&id=367d3ebc&scoped=true&lang=css"

import exportComponent from "/Users/chrisfinlayson/Desktop/WORK/riverhawk-nest/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-367d3ebc"]])

export default __exports__